<template>
  <v-list-item @click="edit_dialog = !edit_dialog">
    <v-layout row>
      <v-flex
        xs11
        style="
          overflow: none;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        "
      >
        {{ url }}
      </v-flex>
    </v-layout>
    <v-dialog v-model="edit_dialog" max-width="590">
      <v-form @submit="editURL">
        <v-card>
          <v-card-title>Edit URL</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex sm3 xs12 style="padding-right: 10px">
                <v-select
                  v-model="edit_method"
                  :items="methods"
                  label="Method"
                ></v-select>
              </v-flex>
              <v-flex sm9 xs12>
                <v-text-field
                  label="URL"
                  type="url"
                  pattern="https?://.*"
                  aria-required="true"
                  placeholder="https://"
                  v-model="edit_url"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex sm4 xs12 style="padding-right: 10px">
                <v-select
                  v-model="edit_service"
                  :items="services"
                  label="Service"
                ></v-select>
              </v-flex>
              <v-flex sm8 xs12>
                <v-textarea
                  v-if="edit_service !== 'webhook'"
                  label="Additional parameters"
                  :placeholder="additional_params_placeholder"
                  v-model="edit_additional_params"
                ></v-textarea>
              </v-flex>
            </v-layout>
            <h5>Secret</h5>
            <CopyField :value="secret"></CopyField>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="error" @click="deleteUrl">Delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="default" @click="edit_dialog = false"
              >Cancel</v-btn
            >
            <v-btn text color="primary" type="submit">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-list-item>
</template>

<script>
import { Functions } from "../../logic/Functions";
import { Notifications } from "../../notification";

export default {
  name: "FunctionUrl",
  props: {
    id: {
      type: Number,
      required: true,
    },
    method: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    secret: {
      type: String,
      required: true,
    },
    service: {
      type: String,
      required: true,
      default: "webhook"
    },
    additional_params: {
      type: Object,
      required: false,
      default: () => { return {}; }
    }
  },
  data() {
    return {
      edit_dialog: false,

      edit_url: this.url,
      edit_method: this.method,
      edit_service: this.service,
      edit_additional_params: this.additional_params,

      methods: Functions.url_methods,
      services: Functions.url_services
    };
  },
  computed: {
    additional_params_placeholder() {
      var index = 0;
      for (var curr of this.services) {
        if (curr.value === this.edit_service) {
          break;
        }
        index++;
      }

      return this.services[index].placeholder;
    }
  },
  mounted() {},
  methods: {
    async editURL(e) {
      e.preventDefault();
      var response = await Functions.editUrl(
        this.id,
        this.edit_method,
        this.edit_url,
        this.secret,
        this.edit_service,
        this.edit_additional_params
      );
      if (response.status === 200) {
        Notifications.show("The URL has been updated.");
        this.edit_dialog = false;
        this.$emit("urlsChanged");
      } else {
        Notifications.show(response.message);
      }
    },
    async deleteUrl(e) {
      e.preventDefault();

      if (confirm("Do you really want to delete this URL?")) {
        var response = await Functions.deleteUrl(
          this.id
        );
        if (response.status === 200) {
          Notifications.show("The URL has been deleted.");
          this.edit_dialog = false;
          this.$emit("urlsChanged");
        } else {
          Notifications.show(response.message);
        }
      }
    }
  },
};
</script>

<style>
</style>